// SchoolConstants.js

// Get All School----
export const GetAllSchool_REQUEST = "GetAllSchool_REQUEST";
export const GetAllSchool_SUCCESS = "GetAllSchool_SUCCESS";
export const GetAllSchool_FAIL = "GetAllSchool_FAIL";

// // Get School by ID----
// export const GetSchoolByItemId_REQUEST = "GetPurchaseOrderItemsByItemId_REQUEST";
// export const GetPurchaseOrderItemsByItemId_SUCCESS = "GetPurchaseOrderItemsByItemId_SUCCESS";
// export const GetPurchaseOrderItemsByItemId_FAIL = "GetPurchaseOrderItemsByItemId_FAIL";

// Add School----
export const AddSchoolDetails_REQUEST = "AddSchoolDetails_REQUEST";
export const AddSchoolDetails_SUCCESS = "AddSchoolDetails_SUCCESS";
export const AddSchoolDetails_FAIL = "AddSchoolDetails_FAIL";

// Put School----
export const PutSchoolDetails_REQUEST = "PutSchoolDetails_REQUEST";
export const PutSchoolDetails_SUCCESS = "PutSchoolDetails_SUCCESS";
export const PutSchoolDetails_FAIL = "PutSchoolDetails_FAIL";










